import { render, staticRenderFns } from "./AccountsTransactions.vue?vue&type=template&id=67ad4870&scoped=true"
import script from "./AccountsTransactions.vue?vue&type=script&lang=js"
export * from "./AccountsTransactions.vue?vue&type=script&lang=js"
import style0 from "./AccountsTransactions.vue?vue&type=style&index=0&id=67ad4870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ad4870",
  null
  
)

export default component.exports